import React, { Component } from 'react';
import { say, suggest } from '../services/api';
import { VolumeSlider, PitchSlider, SpeedSlider, Suggestions } from '.';
import { getCaretCoordinates } from './CaretPosition.js';

export default class Sentence extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playing: false,
      audio: null,
      suggestionsPosition: { top: 0, left: 0, height: 0 },
      suggestions: [],
      suggestionExhausted: false,
      suggestionsClosed: false,
      suggestionsCurrent: null,
      audioIsText: false,
      lastWords: []
    };
    this.player = React.createRef();
    this.textarea = React.createRef();
    this.suggestionswidth = 300;
  }

  updateAudio = (callback) => {
    const audiotext = this.props.text;
    say(this.props.text, this.props.speed, this.props.pitch, this.props.volume).then((blob) =>
      this.setState({ audio: URL.createObjectURL(blob), audioIsText: (audiotext === this.props.text) }, (this.state.playing) ? this.play : null)
    );
  }

  extendText = (tail) => {
    /**
     * @FIXME: put this updating in a better place.
     */
    const m = (this.props.text + tail + ' ').match(/(\w+)\W+(\w+)\W+$/),
          lastWords = (m) ? [m[1].toLowerCase(), m[2].toLowerCase()] : this.state.lastWords;

    this.setState({
      audioIsText: false,
      suggestions: [],
      lastWords: lastWords
    }, () => {
      if (lastWords.length === 2 && (lastWords[0] !== this.state.lastWords[0] || lastWords[1] !== this.state.lastWords[1])) {
        this.loadSuggestions(lastWords[0], lastWords[1]);
      }
      this.updateAudio();
      this.textarea.current.focus();
      this.setState({ suggestionsPosition: this.defineSuggestionsPosition() });
    });
    this.handleTextChange(this.props.text + tail + ' ');
  }

  loadSuggestions (w1, w2, extend) {
    const self = this;
    suggest(w1, w2)
      .then((suggestions) => {
        if (!extend) {
          self.setState({ suggestions, 'suggestionsExhaused': false, 'suggestionsClosed': false, 'suggestionsCurrent': null })
        } else {
          var oldSuggestions = self.state.suggestions,
              newSuggestions = suggestions.filter((v) => !oldSuggestions.includes(v));

          if (newSuggestions.length === 0) {
            self.setState({ 'suggestionsExhaused': true });
          } else {
            const combined = oldSuggestions;
            newSuggestions.forEach((v) => { combined.push(v) });
            self.setState({ suggestions: combined, 'suggestionsExhaused': false });
          }
        }
      })
  }

  loadMoreSuggestions = () => {
    this.loadSuggestions(this.state.lastWords[0], this.state.lastWords[1], true);
  }

  closeSuggestions = (e) => {
    if (!this.state.suggestionsClosed) {
      if (e) {
        e.preventDefault();
      }
      this.setState({ 'suggestionsClosed': true});
    }
  }

  highlightNextSuggestion = (e) => {
    if (this.state.suggestions.length > 0 && !this.state.suggestionsClosed) {
      if (e) {
        e.preventDefault();
      }
      let next;
      if (this.state.suggestionsCurrent === null) {
        next = 0;
      }
      else if (this.state.suggestionsCurrent === this.state.suggestions.length - 1) {
        next = -1;
      } else {
        next = this.state.suggestionsCurrent + 1;
      }
      this.setState({
        suggestionsCurrent: next
      });
    }
  }

  highlightPrevSuggestion = (e) => {
    if (this.state.suggestions.length > 0 && !this.state.suggestionsClosed) {
      if (e) {
        e.preventDefault();
      }
      let next;
      if (this.state.suggestionsCurrent === null) {
        next = -1;
      }
      else if (this.state.suggestionsCurrent === -1) {
        next = this.state.suggestions.length - 1;
      }
      else {
        next = this.state.suggestionsCurrent - 1;
      }
      this.setState({
        suggestionsCurrent: next
      });
    }
  }

  pickCurrentSuggestion = (e) => {
    if (this.state.suggestionsCurrent === -1) {
      if (e) {
        e.preventDefault();
      }
      this.loadMoreSuggestions();
    }
    else if (this.state.suggestionsCurrent !== null && this.state.suggestions.length > 0 && !this.state.suggestionsClosed){
      if (e) {
        e.preventDefault();
      }
      this.extendText(this.state.suggestions[this.state.suggestionsCurrent]);
    }
  }

  manualEdit = (e) => {
    const text = e.target.value,    
          m = text.match(/(\w+)\W+(\w+)\W+$/),
          lastWords = (m) ? [m[1].toLowerCase(), m[2].toLowerCase()] : this.state.lastWords;
    
    if (lastWords.length === 2 && (lastWords[0] !== this.state.lastWords[0] || lastWords[1] !== this.state.lastWords[1])) {
      this.loadSuggestions(lastWords[0], lastWords[1]);
    }
    
    this.setState({
      suggestionsPosition: this.defineSuggestionsPosition(),
      lastWords: lastWords,
      audioIsText: false 
    });

    this.handleTextChange(text);
  }

  pausePlay = () => {
    if (this.player.current.paused) {
      this.play();
    } else {
      this.pause();
    }
  }

  play = () => {
    this.setState({ playing: true }, () => {
      var y = this.textarea.current.getBoundingClientRect().y,
          target = 150,
          distance = y - target;

      // scroll(distance, 250);
      window.scrollBy({top: distance, behavior: 'smooth' });
    });
    if (!this.state.audioIsText) {
      this.updateAudio()
    } else {
      this.player.current.play();
    }
    if (this.props.onPlay) this.props.onPlay();
  }

  pause = () => {
    this.player.current.pause();
    this.setState({ playing: false });
    if (this.props.onPause) this.props.onPause();
  }

  handleEnded = () => {
    this.setState({ playing: false });
    if (this.props.onEnded) {
      this.props.onEnded()
    }
  }

  handleLoopChange = () => {
    if (this.props.onLoopChange) { this.props.onLoopChange(!this.props.loop) }
  };

  handlePitchChange = (v) => {
    if (this.props.onPitchChange) { this.props.onPitchChange(v) }
  };

  handleSpeedChange = (v) => {
    if (this.props.onSpeedChange) { this.props.onSpeedChange(v) }
  };
  
  handleVolumeChange = (v) => {
    if (this.props.onVolumeChange) { this.props.onVolumeChange(v) }
  };

  handleTextChange = (v) => {
    if (this.props.onTextChange) { this.props.onTextChange(v) }
  };

  componentDidMount = () => {
    const el = this.textarea.current;
    if (el.scrollHeight - 1 > el.getBoundingClientRect().height) {
      this.textarea.current.style.minHeight = Math.ceil(this.textarea.current.scrollHeight) + 'px';
    }
  }

  componentDidUpdate = () => {
    const el = this.textarea.current;
    if (el.scrollHeight - 1 > el.getBoundingClientRect().height) {
      this.textarea.current.style.minHeight = Math.ceil(this.textarea.current.scrollHeight) + 'px';
    }
  }

  handleFocus = () => {
    this.props.onFocus();
  }

  defineSuggestionsPosition = () => {
    if (!this.caretPosition) {
      this.caretPosition = getCaretCoordinates(this.textarea.current);
    }

    const caret = this.caretPosition(this.textarea.current.selectionEnd),
          textareaRect = this.textarea.current.getBoundingClientRect(),
          windowHeight = window.innerHeight,
          clientY = caret.top + textareaRect.top;

    console.log(clientY, windowHeight)

    if (clientY > (windowHeight * .6)) {
      return {left: Math.min(caret.left, textareaRect.width - (this.suggestionswidth + 10)), bottom: (textareaRect.height - caret.top)};
    } else {
      return {left: Math.min(caret.left, textareaRect.width - (this.suggestionswidth + 10)), top: caret.top + 50};
    }
  }

  render() {
     /**
     * Fix;
     */

    const props = this.props;

    // top: this.state.suggestionsPosition.top + this.state.suggestionsPosition.height,
    // left: Math.min(this.state.suggestionsPosition.left, textareaWidth - this.suggestionswidth)

    const textareaWidth = (this.textarea.current) ? this.textarea.current.getBoundingClientRect().width - 10 : 999,
          suggestionsStyle = {
            width: this.suggestionswidth,
            ...this.state.suggestionsPosition
          };
    
    const playControl = (this.state.playing) ? <button onClick={this.pause}>⏸</button> : <button onClick={this.play}>▶</button>;
          
    const suggestions = (!this.state.suggestionsClosed && this.state.suggestions.length > 0) ? <Suggestions highlighted={this.state.suggestionsCurrent} className="suggestions" suggestions={this.state.suggestions} style={suggestionsStyle} onSelect={ this.extendText } onLoadMore={ this.loadMoreSuggestions } loadMore = { !this.state.suggestionsExhaused }/> : '';

          return (
      <div className="sentence" data-playing={this.state.playing}>
        <nav className="controls">
          <section className="control performance-hide"> 
            <button onClick={this.props.onRemove}>❌</button>
          </section>
          <PitchSlider onChange={this.handlePitchChange} value={props.pitch} />
          <SpeedSlider onChange={this.handleSpeedChange} value={props.speed} />
          <VolumeSlider onChange={this.handleVolumeChange} value={props.volume} />
          <section className="control checkbox"><label><input type="checkbox" checked={props.loop} onChange={this.handleLoopChange} />loop</label></section>
          <section className="control">{ playControl }</section>
          <section className="control">
            <button onClick={this.updateAudio}>↺</button>
          </section>
          <audio ref={this.player} src={this.state.audio} onEnded={this.handleEnded} loop={props.loop} />
        </nav>
        <section className="text">
          <textarea value={props.text} onChange={this.manualEdit} ref={this.textarea} onFocus={this.handleFocus} />
          { suggestions }
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sentence.js